import React from 'react';
import Bem, { decl, bool2string } from '@yandex-lego/i-bem-react';

import _messageBox__tail from "./__tail/message-box__tail.react.js";

var Tail = _messageBox__tail.applyDecls();

import "./__tail/message-box__tail.css";
import _messageBox__close from "./__close/message-box__close.react.js";

var Close = _messageBox__close.applyDecls();

import "./__close/message-box__close.css";
import _messageBox__corner from "./__corner/message-box__corner.react.js";

var Corner = _messageBox__corner.applyDecls();

import "./__corner/message-box__corner.css";
import "./__buttons/message-box__buttons.css";
import "./message-box.css";
import "./_size/message-box_size_s.css";
import "./_size/message-box_size_m.css";
import "./_size/message-box_size_l.css";
import "./_size/message-box_size_xl.css";
import "./message-box.css";
import "./_view/message-box_view_default.css";
import "./message-box.css";
import "./_tone/message-box_tone.css";
import "./_tone/message-box_tone_default.css";


export default decl({
    block: 'message-box',

    mods: function mods(_ref) {
        var size = _ref.size,
            type = _ref.type,
            align = _ref.align,
            width = _ref.width,
            view = _ref.view,
            tone = _ref.tone,
            hasClose = _ref.hasClose,
            opaque = _ref.opaque;

        return {
            'custom-width': bool2string(width),
            'has-close': bool2string(hasClose),
            opaque: bool2string(opaque),
            size: size,
            type: type,
            view: view,
            tone: tone,
            align: align || type === 'text' ? 'left' : 'center'
        };
    },
    content: function content(_ref2) {
        var text = _ref2.text,
            textLeft = _ref2.textLeft,
            textRight = _ref2.textRight,
            children = _ref2.children,
            hasClose = _ref2.hasClose;

        var replaceAll = false;
        if (typeof children === 'string') {
            text = children;
        } else if (children) {
            replaceAll = true;
        }
        var _props = this.props,
            hasTail = _props.hasTail,
            width = _props.width,
            backgroundElement = _props.backgroundElement,
            buttons = _props.buttons,
            corner = _props.corner;


        var tail = Boolean(hasTail);

        var content = [];
        if (text) {
            if (textLeft || textRight) {
                var wrapper = React.createElement(
                    Bem,
                    { key: 'text-wrap', block: 'message-box', elem: 'text-wrap' },
                    textLeft && React.createElement(
                        Bem,
                        { key: 'left', block: 'message-box', elem: 'text-left' },
                        textLeft
                    ),
                    React.createElement(
                        Bem,
                        { key: 'text', block: 'message-box', elem: 'text' },
                        text
                    ),
                    textRight && React.createElement(
                        Bem,
                        { key: 'right', block: 'message-box', elem: 'text-right' },
                        textRight
                    )
                );
                content.push(wrapper);
            } else {
                content.push(React.createElement(
                    Bem,
                    { key: 'text', block: 'message-box', elem: 'text' },
                    text
                ));
            }
        }
        if (hasClose) {
            content.push(React.createElement(Close, { key: 'close', onClick: this.props.onClose }));
        }

        var wrap = [React.createElement(
            Bem,
            { key: 'backdrop', block: 'message-box', elem: 'backdrop' },
            tail && React.createElement(Tail, null),
            backgroundElement && React.createElement(
                Bem,
                { block: 'message-box', elem: 'backelem' },
                backgroundElement
            )
        ), React.createElement(
            Bem,
            { key: 'content', block: 'message-box', elem: 'content', attrs: { style: { width: Number(width) } } },
            replaceAll ? children : content
        ), buttons && React.createElement(
            Bem,
            { key: 'buttons', block: 'message-box', elem: 'buttons' },
            buttons
        ), corner];

        return wrap;
    }
}, {
    Corner: Corner,
    Tail: Tail,
    defaultProps: {
        view: 'default',
        tone: 'default'
    }
});